import { useDioxAddressContext } from 'common/hooks'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import Button from '../Button'
import walletLogo from '../../../assets/img/walletLogo.png'
import error from '../../../assets/img/error.png'
import link from '../../../assets/img/link.png'
import { AppProp } from './wrap'

type ContainerProps = {
  app: AppProp
  children: JSX.Element
  localAddress?: string
}

const ConnectBox = styled.div`
  width: 468px;
  height: 303px;
  background: linear-gradient(
      180deg,
      rgba(224, 194, 134, 0.2) 0%,
      rgba(224, 194, 134, 0.082) 8.52%,
      rgba(224, 194, 134, 0.044) 14.28%,
      rgba(224, 194, 134, 0) 21.25%
    ),
    #1a1919;
  border: 1px solid #3a3939;
  box-shadow: 0px 12px 32px rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .connect-header {
    display: flex;
    margin-top: 40px;
    align-items: center;
    .connect-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 64px;
      img {
        width: 64px;
        height: 64px;
        border-radius: 100%;
        margin-bottom: 8px;
      }
      .connect-name {
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        white-space: nowrap;
      }
    }
    .error {
      width: 28px;
      height: 28px;
      margin: 0 16px;
    }
    .link {
      width: 28px;
      height: 4px;
    }
    .link-group {
      margin: 0 32px;
      display: flex;
      align-items: center;
      padding-bottom: 28px;
    }
  }
  .divide {
    width: 388px;
    margin: 24px 0;
    height: 1px;
    background: #3a3939;
  }
  .desc {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 32px;
  }
`
const Container = (props: ContainerProps) => {
  const { address, bindAppAddress } = useDioxAddressContext()

  const renderContainer = useMemo(() => {
    if (!address)
      return (
        <ConnectBox className="container-connect">
          <div className="connect-header">
            <div className="connect-box">
              <img src={props.app.logo} alt={props.app.title} />
              <span className="connect-name">{props.app.title}</span>
            </div>
            <div className="link-group">
              <img className="link" src={link.src} alt="link" />
              <img className="error" src={error.src} alt="error" />
              <img className="link" src={link.src} alt="link" />
            </div>
            <div className="connect-box">
              <img src={walletLogo.src} alt="DioWallet" />
              <span className="connect-name">DioWallet</span>
            </div>
          </div>
          <div className="divide"></div>
          <p className="desc">You haven‘t connected to wallet yet</p>
          <Button type="primary" onClick={() => bindAppAddress && bindAppAddress()}>
            Connect
          </Button>
        </ConnectBox>
      )
    return <div className="container-page">{props.children}</div>
  }, [address, props, bindAppAddress])

  return (
    <div className="container-w container-h">
      {renderContainer}
      {props.app?.bg && (
        <div className="container-bg">
          <img src={props.app?.bg} alt="bg" />
        </div>
      )}
    </div>
  )
}

export default Container
